import { z } from "zod";

export const ConversationUpdateSchema = z
  .object({
    type: z.literal("conversation_update"),
  })
  .passthrough();

export type ConversationUpdate = z.infer<typeof ConversationUpdateSchema>;
